import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useFormik } from 'formik';

import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import AppInput from 'shared/AppInput';
import AppNotification from 'shared/AppNotification';

import axios from 'utils/axios-rails';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
}

const defaultProps = {

}

// For now just receives different qty/amount pairs to generate a sole file with them
// Virtual union - Not saved to DB
const GiftCardOrderUnionNew = (props) => {
  const [message, setMessage] = useState(null);
  const [formIdCounter, setFormIdCounter] = useState(2); // Should start with the number of elements on formik initial orders[]

  const closeToast = () => setMessage(null);

  const handleSubmit = async (values) => {
    console.log(values);
    try {
      const response = await axios.post(props.submitURL, {
        gift_card_order: values
      });
      formik.resetForm();
      setMessage(response.data.message);
    } catch (error) {
      const ex = error;
      console.log("MAX", error);
      if(error.response && error.response.data){
        formik.setErrors(error.response.data);
      } // errors
    }
    formik.setSubmitting(false);
  };

  const removeItem = (itemToRemoveFormId) => {
    const newOrders = formik.values.orders.filter( (item, index) => item.formId != itemToRemoveFormId ); // Maybe there is a better way for this
    formik.setFieldValue("orders", newOrders);
  }

  const addNewItem = () => {
    const newOrders = [ ...formik.values.orders, { quantity: 0, amount: "", formId: formIdCounter } ]
    formik.setFieldValue("orders", newOrders);
    setFormIdCounter(formIdCounter + 1);
  }

  const formik = useFormik({
    initialValues: {
      notes: "",
      orders: [ // GC Orders in Union
        { quantity: 0, amount: "", formId: 0, displayAsMoney: true },
      ]
    },
    onSubmit: handleSubmit
  });

  const formatPrice = (value) => {
    // Convert to a number first
    const number = parseFloat(value);
    if (isNaN(number)) {
      return '';
    }

    // Format the number with commas as thousands separators
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(number);
  };

  const { values, errors } = formik;

  return (
    <Container className="mt20">
      <AppNotification
        open={ !!message }
        message={ message }
        severity="success"
        handleClose={ closeToast }
        position={{ vertical: 'top', horizontal: 'right' }}
      />
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Generar Manualmente</Typography>
          <form onSubmit={ formik.handleSubmit } >

            <Box sx={{ py: 1.5 }}>
              <AppInput
                label="Notas"
                name="notes" value={ values.notes } onChange={ formik.handleChange } placeholder=""
                error={ errors.notes } />
            </Box>
            <Divider />

            { values.orders.map( (gc_order, index) => {
              const formattedPrice = gc_order.displayAsMoney ? formatPrice(gc_order.amount) : gc_order.amount;
              return(
                <React.Fragment key={index}>
                  <Grid container spacing={2} alignItems="flex-end" sx={{ py: 1.5 }}>
                    <Grid item xs={12} sm={5}>
                      <AppInput
                        label="Cantidad"
                        name={`orders[${index}].quantity`}
                        value={ gc_order.quantity } onChange={ formik.handleChange } placeholder=""
                        error={ errors.quantity }
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <AppInput
                        label="Monto (Colones)"
                        attachedText="₡"
                        name={`orders[${index}].amount`}
                        value={ formattedPrice }
                        onChange={ formik.handleChange }
                        placeholder=""
                        // Use onFocus and onBlur to toggle between raw and formatted values (when losing focus set Money format, when focus set number for easier input)
                        onFocus={ () => formik.setFieldValue(`orders[${index}].displayAsMoney`, false)}
                        onBlur={ () => formik.setFieldValue(`orders[${index}].displayAsMoney`, true) }
                        error={ errors.amount } />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Button onClick={ () => removeItem(gc_order.formId) } variant="contained" color="error" disableElevation>Eliminar</Button>
                    </Grid>
                  </Grid>
                  <Divider />
                </React.Fragment>
              )
            })}

            <Box sx={{ py: 1.5 }}>
              <Button fullWidth onClick={ addNewItem } variant="contained" color="primary" disableElevation>Agregar</Button>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button className="border-0 pv8 ph16 font-weight-bold" color="brandYellow" variant="contained" disableElevation type="submit" disabled={ formik.isSubmitting }>
                { formik.isSubmitting ? "ENVIANDO..." : "CREAR" }
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Container>
  )
};

GiftCardOrderUnionNew.propTypes = propTypes;
GiftCardOrderUnionNew.defaultProps = defaultProps;

export default GiftCardOrderUnionNew;
